import { createTestId, normalizeForTestId } from '@ibk/shared-utils';
export const BENEFITS_ONBOARDING_WIZARD_ROOT_TEST_ID = createTestId('benefits', 'onboarding', 'wizard');
export const BENEFITS_ONBOARDING_SPOTLIGHT_DEFAULT_TEST_ID = createTestId('benefits', 'onboarding', 'spotlight');
const LEGACY_WIZARD_TEST_ID_ROOTS = new Set(['BenefitsOnboardingWizard']);
export function resolveBenefitsOnboardingWizardTestIdRoot(prop) {
    if (!prop || LEGACY_WIZARD_TEST_ID_ROOTS.has(prop)) {
        return BENEFITS_ONBOARDING_WIZARD_ROOT_TEST_ID;
    }
    return normalizeForTestId(prop.replace(/([a-z\d])([A-Z])/g, '$1-$2'));
}
export function benefitsOnboardingWizardTestIds(root) {
    const r = resolveBenefitsOnboardingWizardTestIdRoot(root);
    const skipConfirm = createTestId(r, 'skip', 'confirm');
    return {
        root: r,
        skipConfirm,
        skipCancel: createTestId(r, 'skip', 'cancel'),
        skipConfirmBackdrop: createTestId(r, 'skip', 'confirm', 'backdrop'),
        spotlight: createTestId(r, 'spotlight'),
        spotlightStepIndicator: createTestId(r, 'spotlight', 'step-indicator'),
        spotlightForward: createTestId(r, 'spotlight', 'forward'),
        spotlightBack: createTestId(r, 'spotlight', 'back'),
        spotlightClose: createTestId(r, 'spotlight', 'close'),
    };
}
export const defaultBenefitsOnboardingWizardTestIds = benefitsOnboardingWizardTestIds(undefined);
